class ProductModal extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('.product-media-modal__toggle');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.hide();
      });
    }

    this.addEventListener('click', (e) => {
      if (e.target === this) {
        this.hide();
      }
    });
  }

  show() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  hide() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('product-modal', ProductModal);